import type { IssueNavigatorPluggableItemsQuery_jiraWebSection_webItems_nodes_target as Target } from '../services/query/__generated_apollo__/IssueNavigatorPluggableItemsQuery';

export const buildStyleClass = (target: Target): string => {
	const classes: Array<string> = [];

	switch (target.type) {
		case 'DIALOG':
			classes.push('ap-dialog');
			break;
		case 'DIALOG_MODULE':
			classes.push('ap-dialog');
			if ('targetKey' in target && target.targetKey != null) {
				classes.push(`ap-target-key-${target.targetKey}`);
			}
			break;
		case 'INLINE_DIALOG':
			classes.push('ap-inline-dialog');
			break;
		default:
			break;
	}

	if (target.addonKey != null) {
		classes.push(`ap-plugin-key-${target.addonKey}`);
	}

	if (target.moduleKey != null) {
		classes.push(`ap-module-key-${target.moduleKey}`);
	}

	return classes.join(' ');
};

export const isInOrIsIFrame = (element: HTMLElement, idLooseMatchList: string[]): boolean => {
	const isIFrameWithMatchingId =
		element.nodeName === 'IFRAME' && !!idLooseMatchList.find((id) => element.id.match(id));
	const isDifferentOwnerDocument = element.ownerDocument !== document;
	return isIFrameWithMatchingId || isDifferentOwnerDocument;
};

export const translateAppTypeToAnalyticsType = (
	type?: Target['type'] | null,
): 'dialog' | 'dialog_module' | 'inline_dialog' | 'unknown' => {
	switch (type) {
		case 'DIALOG':
			return 'dialog';
		case 'DIALOG_MODULE':
			return 'dialog_module';
		case 'INLINE_DIALOG':
			return 'inline_dialog';
		default:
			return 'unknown';
	}
};
